import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ErrorResponse } from 'store/ReduxTypes';
import { NutritionPlanResponse, RecipeResponse } from './NutritionTypes';
import { api } from '@utils/api';

/* ─────────── 1. POST  /api/v1/nutrition-requests ─────────── */
export const requestNutritionPlanOperation = createAsyncThunk<
  NutritionPlanResponse,
  number, // instance_id
  { rejectValue: ErrorResponse }
>('nutrition/requestPlan', async (instanceId, { rejectWithValue }) => {
  try {
    const { data } = await api.post<NutritionPlanResponse>(
      '/nutrition-requests',
      {},
      { params: { instance_id: instanceId } },
    );
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ─────────── 2. GET  /api/v1/nutrition-requests/latest ─────────── */
export const getLatestNutritionPlanOperation = createAsyncThunk<
  NutritionPlanResponse,
  void,
  { rejectValue: ErrorResponse }
>('nutrition/latestPlan', async (_, { rejectWithValue }) => {
  try {
    const { data } = await api.get<NutritionPlanResponse>('/nutrition-requests/latest');
    return data;
  } catch (err) {
    console.error('API error', err);
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message, status: e.response?.status });
  }
});

/* ─────────── 3. GET  /api/v1/nutrition-requests/{request_id} ─────────── */
export const getNutritionPlanStatusOperation = createAsyncThunk<
  NutritionPlanResponse,
  number,
  { rejectValue: ErrorResponse }
>('nutrition/planStatus', async (requestId, { rejectWithValue }) => {
  try {
    const { data } = await api.get<NutritionPlanResponse>(`/nutrition-requests/${requestId}`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* ─────────── 4. POST  /api/v1/resources/recipes ─────────── */
export const fetchRecipeOperation = createAsyncThunk<
  RecipeResponse,
  string, // meal name
  { rejectValue: ErrorResponse }
>('nutrition/fetchRecipe', async (mealName, { rejectWithValue }) => {
  try {
    const { data } = await api.post<RecipeResponse>('/resources/recipes', {
      name: mealName,
    });
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
